import React, { Component, Fragment } from "react";
import axios from "axios";
import Spinner from 'react-bootstrap/Spinner';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Table from '../Components/Table';
import Button from '../Components/Button'
import AutoComplete from "../Components/AutoComplete";
import settings from '../helpers/Settings'
import ReactTooltip from 'react-tooltip'
let { KayanURL, apiToken } = settings;

class PayerFactorManagement extends Component {

  constructor(props) {
    super(props)
    this.state = {
      compName: localStorage.getItem("SanadCompany"),
      providerName: "",
      empType: localStorage.getItem('SanadType'),
      empName: "",
      payerName: "",
      payNames: [],
      provNames: [],
      provLicenses: [],
      payLicenses: [],
      provider_id: "",
      payer_id: "",
      license: "",
      factor: "",
      fixedPayerName: "",
      fixedPayerLicense: "",
      providers: [],
      payers: [],
      provFactors: [],
      provPayers: [],
      serverError: null,
      error: null,
      data: [],
      allFactors: [],
      licenses: [],
      payer_names: [],
      factors: [],
      username: "",
      name: null,
      leftStyle: "center",
      success: false,
      apiResult: null,
      allProviders: [],
      TableRows: null,
      onAdd: false,
      onUpdate: false,
      onDelete: false,
      startUpdate: false,
      addSuccess: false,
      updateSuccess: false,
      deleteSuccess: false,

      // Auto Complete
      items: [],
      providerACText: '',
      providerACMatched: [],
      providerACStyle: 'AutoCompleteInput',
      now: 0
    }

  };

  getProvidersInfo = async () => {
    let { data } = this.state;
    let items = [];

    data.map(item => {
      if (item.name == this.state.payerName) {
        this.setState({ payer_id: item.license }, () => {
          axios
            .put(KayanURL + 'api/sanad/get_providers', { apiToken })
            .then(({ data }) => {
              let d = data;
              if (d.success) {
                this.setState({
                  allProviders: d.data
                })
                d.data.map(item => {
                  items.push(item.provider_id + " , " + item.provider_name);
                  this.setState({ items })
                })

              } else {
                this.setState({
                  error: d.error
                })
              }
            })
            .catch(() => {
              this.setState({ serverError: "There is a server error!" });
            })

          axios
            .put(KayanURL + 'api/sanad/get_factors', { apiToken, notProvider: true })
            .then(({ data }) => {
              let d = data;
              if (d.success) {
                let allFactors = d.data.filter(payer => payer.payer_id == this.state.payer_id).sort((factorA, factorB) => factorA.provider_name.localeCompare(factorB.provider_name));
                let licenses = allFactors.map(provider => provider.provider_id);
                let provider_names = allFactors.map(provider => provider.provider_name);
                let factors = allFactors.map(provider => provider.factor);

                if (this.state.onDelete || this.state.onUpdate || this.state.onAdd) {
                  setTimeout(() => {
                    this.setState({
                      onDelete: this.state.onDelete ? false : this.state.onDelete,
                      deleteSuccess: this.state.onDelete ? this.state.onDelete : this.state.deleteSuccess,
                      onAdd: this.state.onAdd ? false : this.state.onAdd,
                      addSuccess: this.state.onAdd ? this.state.onAdd : this.state.addSuccesss,
                      onUpdate: this.state.onUpdate ? false : this.state.onUpdate,
                      updateSuccess: this.state.onUpdate ? this.state.onUpdate : this.state.updateSuccess,
                      licenses,
                      provider_names,
                      factors,
                      allFactors,
                      TableRows: this.prepareFactorsTable(allFactors)
                    })
                  }, '5000');
                } else {
                  this.setState({ licenses, provider_names, factors, allFactors, TableRows: this.prepareFactorsTable(allFactors) })
                }
              } else {
                this.setState({ error: d.error })
              }
            })
            .catch(() => {
              this.setState({ serverError: "There is a server error!" });
            })
        })
      }
    })
  }

  getCompaniesInfo = async () => {
    let { empType } = this.state;
    await axios
      .put(KayanURL + 'api/sanad/get_kayan_payers', { apiToken })
      .then(({ data }) => {
        if (data.success) {
          data = data.data;
          this.setState({ data }, () => {
            if (empType == 'admin')
              this.setState({
                payerName: this.state.data[0]['name'],
                payer_id: this.state.data[0]['license']
              }, () => {
                this.getProvidersInfo()
              })

            else {
              this.getProvidersInfo()
            }

          })

        } else {
          this.setState({ error: data.error })

        }
      })

      .catch(() => {
        this.setState({ serverError: "There is a server error!" });
      })
  }

  componentDidMount = () => {
    const { history } = this.props;

    if (!apiToken) {
      history.push(`/Sanad/loginAsEmployee`, { errorMsg: "You need to sign in or sign up" });
    }
    else {
      if (this.state.compName != null && this.state.compName != "" && this.state.compName != "Kayan"
        && this.state.compName != undefined) {
        this.setState({ payerName: this.state.compName })
      }

      this.getCompaniesInfo();

    }
  }

  prepareFactorsTable = (items) => {
    let TableRows = [];
    if (items && items.length > 0) {
      items.forEach((item, index) => {
        let row = {};
        row['Id'] = index + 1;
        row['License'] = item['provider_id'];
        row['Name'] = item['provider_name'];
        row['Factor'] = item['factor'];
        row['Action'] = [
          <div key={index}>
            <Button Style="BS12" Value="Update" onClick={() => this.onProviderInfoUpdateClick(index)} />
            <Button Style="BS12" Value="Delete" onClick={() => this.deleteFactor(index)} />
          </div>
        ]
        TableRows.push(row);
      })
    }
    return TableRows;
  }

  handleProviderChange = (e) => {
    e.preventDefault();
    this.setState({
      payerName: e.target.value.split(" , ")[1].trim(),
      payerId: e.target.value.split(" , ")[0].trim()
    }, () => {
      this.setState({ TableRows: null }, () => {
        this.getProvidersInfo()
      })
    })
  }

  onProviderInfoUpdateClick = (index) => {
    this.setState({
      startUpdate: true,
      provider_id: this.state.licenses[index],
      providerName: this.state.payer_names[index],
      factor: this.state.factors[index],
      error: null
    })
  }

  addFactor = (e) => {
    e.preventDefault();

    this.setState({
      onAdd: true,
    })

    let my_data = {
      payer_id: this.state.payer_id,
      provider_id: this.state.provider_id,
      provider_name: this.state.providerName,
      factor: this.state.factor
    }
    axios
      .put(KayanURL + 'api/sanad/add_factor', { my_data, notProvider: true, apiToken })
      .then(({ data }) => {

        if (data.success) {
          this.setState({
            apiResult: data.result,
            success: true,
            provider_id: "",
            providerName: "",
            factor: ""
          }, () => {
            this.getProvidersInfo()
          })
        } else {
          this.setState({
            error: data.error,
            onAdd: false,
            addSuccess: true
          })
        }
      })
      .catch(() => {
        this.setState({ serverError: "There's a server error!" })
      })
  }

  updateFactor = (e) => {
    e.preventDefault();
    this.setState({
      onUpdate: true
    })

    let my_data = {
      payer_id: this.state.payer_id,
      provider_id: this.state.provider_id,
      factor: this.state.factor
    }

    axios
      .put(KayanURL + 'api/sanad/update_factor', { my_data, notProvider: true, apiToken })
      .then(({ data }) => {
        if (data.success) {
          this.setState({
            apiResult: data.result,
            provider_id: "",
            factor: ""
          }, () => {
            this.getProvidersInfo()
          })
        } else {
          this.setState({
            error: data.error,
            onUpdate: false,
            updateSuccess: true
          })
        }
      })
      .catch(() => {
        this.setState({ error: "There is a server error" });
      })
  }

  deleteFactor = (index) => {

    this.setState({
      onDelete: true
    })

    let my_data = {
      payer_id: this.state.payer_id,
      provider_id: this.state.licenses[index]
    }

    axios
      .put(KayanURL + 'api/sanad/delete_factor', { my_data, notProvider: true, apiToken })
      .then(({ data }) => {
        if (data.success) {
          this.setState({
            apiResult: data.result,
            provider_id: ""
          }, () => {
            this.getProvidersInfo()

          })
        } else {
          this.setState({
            error: data.error,
            onDelete: false,
            deleteSuccess: true
          })
        }
      })
  }

  // Handle Auto Complete Actions
  handleACInputChange = (e) => {
    const value = e.target.value;
    let matched = [];
    this.setState({
      success: false,
      error: null,
      onAdd: false,
      addSuccess: false,
      onDelete: false,
      deleteSuccess: false,
      onUpdate: false,
      updateSuccess: false
    });

    if (value.length > 0) {
      let regValue = value.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&').toLowerCase();
      const regex = new RegExp(`${regValue}`, 'g');
      matched = this.state.items.sort().filter(v => regex.test(v.toLowerCase()))
      matched.length > 0 ? this.setState({ providerACStyle: 'ACInputOnChangingStyle' }) : this.setState({ providerACStyle: 'AutoCompleteInput' })
      this.setState({ providerACMatched: matched, providerACText: value });
    } else {
      this.setState({ providerACMatched: matched, providerACText: value, providerACStyle: 'AutoCompleteInput' })
    }
  }

  handleACItemSelection = (value) => {
    let provider_license = value.split(',')[0].trim();
    let provider_name = value.split(',')[1].trim();
    this.setState(() => ({
      providerACText: value,
      providerACMatched: [],
      providerACStyle: 'AutoCompleteInput',
      provider_id: provider_license,
      providerName: provider_name
    }))
  }

  // Render Progress Bar
  renderProgressBar() {
    let { now, success } = this.state;
    setTimeout(() => {
      this.setState({
        now: !success && now < 100 ? now + 20 : 100
      }, this.renderProgressBar())
    }, '800')
  }

  render() {
    const { providerACText, providerACMatched, providerACStyle, error, serverError, now, success } = this.state;

    if (success)
      setTimeout(() => {
        document.getElementById("factor").value = '';
        this.setState({
          success: false,
          providerACText: ""
        })
      }, '6500')


    if (!error && (this.state.addSuccess || this.state.updateSuccess || this.state.deleteSuccess))
      setTimeout(() => {
        this.setState({
          addSuccess: false,
          updateSuccess: false,
          deleteSuccess: false
        })
      }, '1500')

    if (serverError)
      return (
        <div style={{ backgroundColor: "rgb(67, 183, 81)", color: "#ffffff", padding: "10px" }}>
          {serverError}
        </div>
      )

    else
      return (
        <Fragment>

          {
            this.state.errorMsg ?
              <div style={{ backgroundColor: "rgb(67, 183, 81)", color: "#ffffff", padding: "10px" }}>
                {this.state.errorMsg}
              </div>
              :
              null
          }


          < div style={{ "padding": "1%" }}>
            <form style={{ "margin": "1% auto" }} onSubmit={this.addFactor}>
              {
                this.state.empType == 'admin' ?

                  <div>
                    <label className="factorLabel">Payer:</label>
                    <br></br>
                    <select className="fullWidthSelect"

                      defaultValue={this.state.providerName}
                      onChange={this.handleProviderChange}>
                      {
                        this.state.data.map((item, index) => {
                          return <option key={index}>{item.license + " , " + item.name}</option>
                        })
                      }
                    </select>
                  </div>
                  :
                  null
              }


              {
                this.state.allProviders && this.state.allProviders.length > 0 ?
                  <Fragment>
                    < div>
                      <label className="factorLabel">Search for provider:</label>
                      <AutoComplete
                        id="ProviderAutoCompleteInput"
                        hint="Search by provider name or license"
                        name="payerInfo"
                        text={providerACText}
                        matched={providerACMatched}
                        Style={providerACStyle}
                        handleAutoCompleteChange={this.handleACInputChange}
                        handleItemSelection={this.handleACItemSelection}
                      />
                    </ div>
                    < div style={{ "padding": "0.5%" }}>
                      <label className="factorLabel">Factor:</label>
                      <input
                        name="factor"
                        id="factor"
                        type="number"
                        min="1"
                        max="3.25"
                        step="0.01"
                        data-tip="This value must be between 1 and 3.25"
                        required
                        className="form-control"
                        placeholder="Enter factor value"
                        onChange={event => {
                          this.setState({ factor: event.target.value });
                        }}
                      />
                      <ReactTooltip />

                    </div>
                    <input type="submit" value="Add" className="BS7 customWidth" />
                  </Fragment>

                  : now ?
                    now < 100 ?
                      < div style={{ "padding": "0.5%" }}>
                        < ProgressBar animated variant="success" now={now} label={`${now}% of Providers Info are gotten`} />
                      </div>
                      : this.state.allProviders && now == 100 && this.state.allProviders.length == 0 ?
                        <p>No Providers for {localStorage.getItem('SanadName')} payer </p>
                        :
                        null
                    :
                    null

              }

              {
                this.state.onAdd && !error ?
                  <div style={{ color: "green" }}> {` The factor is adding`}
                    <Spinner size="sm" animation="grow" variant="success" />
                    <Spinner size="sm" animation="grow" variant="success" />
                    <Spinner size="sm" animation="grow" variant="success" />
                  </div>
                  : this.state.addSuccess && !this.state.onAdd && error ?
                    <div style={{ color: "red" }}> {error} </div>
                    : this.state.addSuccess && !error ?
                      <div style={{ color: "green" }}> {` The factor has been added`} </div>
                      :
                      null
              }
            </form>
          </div>


          {this.state.startUpdate ?
            <div className="popup">
              <form className="popupForm" onSubmit={this.updateFactor}>
                <p style={{ "fontWeight": "bold", "fontSize": "15px", "textAlign": "left" }}> Change {this.state.payerName} Info</p>

                <div style={{ "padding": "1%" }}>
                  <label className="factorLabel">New Factor:</label>
                  <input
                    type="number"
                    id="newfactor"
                    name='factor'
                    placeholder={`Current value is ${this.state.factor}`}
                    style={{ "width": "100%", "padding": "1vh 0.6vw" }}
                    onChange={e => this.setState({ factor: e.target.value })}
                    min="1"
                    max="3.25"
                    step="0.01"
                    data-tip="This value must be between 1 and 3.25"
                    required />
                  <ReactTooltip />

                </div>
                <input type="submit" value={`Update`} className="BS7" />
                {
                  this.state.onUpdate && !error ?
                    <div style={{ color: "green" }}> {` The factor is updating`}
                      <Spinner size="sm" animation="grow" variant="success" />
                      <Spinner size="sm" animation="grow" variant="success" />
                      <Spinner size="sm" animation="grow" variant="success" />
                    </div>
                    : this.state.updateSuccess && !this.state.onUpdate && error ?
                      <div style={{ color: "red" }}> {error} </div>
                      :
                      this.state.updateSuccess && !error ?
                        <div style={{ color: "green" }}> {` The factor has been updated`} </div>
                        :
                        null
                }

                <p style={{ "fontWeight": "bold", "fontSize": "15px", "textAlign": "right", "cursor": "pointer", "margin": "0 2%" }} onClick={() => this.setState({ startUpdate: false, error: null })}> Close </p>
              </form>
            </div >
            : null}

          {
            this.state.TableRows && this.state.allProviders ?
              this.state.TableRows.length > 0 && this.state.allProviders.length > 0
                ?
                <div style={{ "marginBottom": "2%" }}>
                  <p style={{ "fontWeight": "bold", "fontSize": "15px", "textAlign": "left" }}> The {this.state.payerName} Providers Info</p>
                  <Table THead={["Id", "License", "Name", "Factor", "Action"]} TBody={this.state.TableRows} />
                  <br></br>
                  {
                    this.state.onDelete && !error ?
                      <div style={{ color: "green" }}> {` The factor is deleting`}
                        <Spinner size="sm" animation="grow" variant="success" />
                        <Spinner size="sm" animation="grow" variant="success" />
                        <Spinner size="sm" animation="grow" variant="success" />
                      </div>
                      :
                      this.state.deleteSuccess && !this.state.onDelete && error ?
                        <div style={{ color: "red" }}> {error} </div>
                        :
                        this.state.deleteSuccess && !error ? <div style={{ color: "green" }}> {` The factor has been deleted`} </div>
                          :
                          null
                  }
                </div>
                :
                this.state.TableRows.length == 0 ? <>
                  <header>{this.state.payerName} doesn't have any providers yet.</header>
                  <br></br>
                </>
                  : null
              :
              <div>
                <span style={{ textAlign: "center", color: "#3ab449" }}> Getting {this.state.payerName} Providers Info </span>
                <Spinner size="sm" animation="grow" variant="success" />
                <Spinner size="sm" animation="grow" variant="success" />
                <Spinner size="sm" animation="grow" variant="success" />
              </div>
          }
        </Fragment>
      );
  }
}
export default PayerFactorManagement;
